import { checkHttpStatusAuthCheck } from '../../../../../actions/utilAction';
import {
  actionCreator,
  checkHttpStatus,
  Claim_API,
  createSearchUrl,
  GET_APPOINTMENT_DATA_API,
  GET_ICD_API,
  GET_MASTERDATABYNAME,
  GET_PAYER_SERVICE_CODES_API,
  GET_TELEHEALTH_SESSION,
  jsonApiHeader,
  POST_ENCOUNTER_SIGNS_API,
  SAVE_SOAP_API,
  showErrorMessage,
  showSuccessMessage,
  SOAP_API,
  soapActionTypes,
  UPDATE_SERVICE_CODES_BLOCKED_UNIT_API,
} from './../constants/ApiConstants';
import Alert from 'react-s-alert';

// export const getAppConfiguration = () => {
//   return (dispatch, getState) => {
//     dispatch(actionCreator(soapActionTypes.get_appConfig.REQUEST));
//     fetch(`${GET_APPCONFIG}`, {
//       method: 'GET',
//       headers: jsonApiHeader(getState().login.access_token, 'application/json'),
//     })
//       .then(checkHttpStatus)
//       .then(function(response) {
//         dispatch(actionCreator(soapActionTypes.get_appConfig.SUCCESS, response));
//       })
//       .catch(function(error) {
//         console.log('get_app configuration error..', error);
//       });
//   };
// };

export const getMasterData = () => {
  return (dispatch, getState) => {
    // debugger;
    dispatch(actionCreator(soapActionTypes.get_masterdata.REQUEST));
    fetch(`${GET_MASTERDATABYNAME}`, {
      method: 'post',
      body: JSON.stringify({ 'masterdata': 'mastericd,masterstaff,masterservicecode' }),
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then((res)=>checkHttpStatusAuthCheck(res,dispatch,getState))
      .then(function(response) {
        dispatch(actionCreator(soapActionTypes.get_masterdata.SUCCESS, response));
      })
      .catch(function(error) {
        console.log('get master data (soap actions) ..', error);
      });
  };
};

export const getSoapAction = (appt_id, enc_id, isAdmin = false) => {

  return (dispatch, getState) => {
    dispatch(actionCreator(soapActionTypes.get_patient_soap.REQUEST));
    // let query_params = `?appointmentId=${appt_id}&encounterId=${enc_id}&isAdmin=${false}`;
    // console.log(`${SOAP_API}/${appt_id}/${enc_id}`);
    fetch(`${SOAP_API}/${appt_id}/${enc_id}?isAdmin=${isAdmin}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/vnd.api+json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        // console.log(response);
        dispatch(actionCreator(soapActionTypes.get_patient_soap.SUCCESS, response));
      })
      .catch(function(error) {
        // dispatch(actionCreator(soapActionTypes.get_patient_soap.FAILURE));
        console.log('get_patient_soap error', error);
      });
  };
};

export const createClaimAction = (enc_id, isAdmin = false) => {

  return (dispatch, getState) => {
    dispatch(actionCreator(soapActionTypes.create_claim.REQUEST));
    // console.log(`${Claim_API}?patientEncounterId=${enc_id}`);
    fetch(`${Claim_API}?patientEncounterId=${enc_id}&isAdmin=${isAdmin}`, {
      method: 'post',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        // console.log(response);
        Alert.closeAll();
        dispatch(actionCreator(soapActionTypes.create_claim.SUCCESS));
        if (response.statusCode === 1) {
          let successMsg = response.message;
          showSuccessMessage(successMsg);
        } else {
          let errorMsg = response.message;
          showErrorMessage(errorMsg);
        }
        // console.log(response);
      })
      .catch(function(error) {
        dispatch(actionCreator(soapActionTypes.create_claim.FAILURE));
        console.log('get_patient_soap--- create claim error', error);
      });
  };
};

export const savePatientSoapAction = (formData, isGenerateClaim, isAdmin = false) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(soapActionTypes.post_patient_soap.REQUEST));
    let requestType = 'post';
    let fetchAPI = `${SAVE_SOAP_API}?isAdmin=${isAdmin}`;

    fetch(fetchAPI, {
      method: requestType,
      body: JSON.stringify(formData),
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          if (isGenerateClaim && formData.Id) {
            dispatch(createClaimAction(formData.Id, isAdmin));
          } else {
            showSuccessMessage(response.message);
          }
          dispatch(actionCreator(soapActionTypes.post_patient_soap.SUCCESS, response));
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(soapActionTypes.post_patient_soap.SUCCESS, null));
        }
      })
      .catch(function(error) {
        console.log('error-----', error);
      });
  };

};

export const getAppointmentById = (appointment_id) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(soapActionTypes.get_appointment_by_id.REQUEST));
    fetch(`${GET_APPOINTMENT_DATA_API}?appointmentId=${appointment_id}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        dispatch(actionCreator(soapActionTypes.get_appointment_by_id.SUCCESS, response));
      })
      .catch(function(error) {
        console.log('get appointment_by_id error', error);
      });

  };
};

export const getMasterDiagnosisByName = (searchObj) => {
  let query_params = createSearchUrl(searchObj);
  return (dispatch, getState) => {
    dispatch(actionCreator(soapActionTypes.get_ICD_byName.REQUEST));
    fetch(`${GET_ICD_API}${query_params}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/vnd.api+json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        dispatch(actionCreator(soapActionTypes.get_ICD_byName.SUCCESS, response));
      })
      .catch(function(error) {
        console.log(error);
      });
  };
};

// export const getMasterCPTByName = (searchObj) => {
//   let query_params = createSearchUrl(searchObj);
//   return (dispatch, getState) => {
//     dispatch(actionCreator(soapActionTypes.get_CPT_byName.REQUEST));
//     fetch(`${GET_CPT_API}${query_params}`, {
//       method: 'get',
//       headers: jsonApiHeader(getState().login.access_token, 'application/vnd.api+json'),
//     })
//       .then(checkHttpStatus)
//       .then(function(response) {
//         dispatch(actionCreator(soapActionTypes.get_CPT_byName.SUCCESS, response));
//       })
//       .catch(function(error) {
//         console.log(error);
//       });
//   };
// };

// get service codes for the patient payer..
export const getPatientPayerServiceCodes = (searchObj) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(soapActionTypes.getPatientPayerServiceCodes.REQUEST));
    fetch(`${GET_PAYER_SERVICE_CODES_API}?patientId=${searchObj.patientId}&PayerPreference=${searchObj.payerPreference}&date=${searchObj.dateTime}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        dispatch(actionCreator(soapActionTypes.getPatientPayerServiceCodes.SUCCESS, response));
      })
      .catch(function(error) {
        console.log(error);
      });
  };
};

// for update service code blocked unit for the patient payer..
export const updateServiceCodeBlockedUnits = (postObj) => {
  let authProcedureCPTLinkId = postObj.authProcedureCPTLinkId
    , actionName = postObj.actionName;
  return (dispatch, getState) => {
    dispatch(actionCreator(soapActionTypes.updateServiceCodeBlockedUnits.REQUEST));
    fetch(`${UPDATE_SERVICE_CODES_BLOCKED_UNIT_API}/${authProcedureCPTLinkId}/${actionName}`, {
      method: 'PATCH',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        dispatch(actionCreator(soapActionTypes.updateServiceCodeBlockedUnits.SUCCESS, response));
      })
      .catch(function(error) {
        console.log(error);
      });
  };
};

export const getTelehealthSession = (telehealthObj) => {
  let query_params = '?patientID=' + telehealthObj.patientID + '&staffID=' + telehealthObj.staffID + '&startTime=' + telehealthObj.startTime + '&endTime=' + telehealthObj.endTime;

  return (dispatch, getState) => {
    dispatch(actionCreator(soapActionTypes.get_telehealth_session.REQUEST));
    fetch(`${GET_TELEHEALTH_SESSION}${query_params}`, {
      method: 'get',
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        // console.log('response: ', response);
        dispatch(actionCreator(soapActionTypes.get_telehealth_session.SUCCESS, response));
      })
      .catch(function(error) {
        // errorHandler(error);
      });
  };
};


export const saveEncounterSigns = (postData) => {
  return (dispatch, getState) => {
    dispatch(actionCreator(soapActionTypes.post_EncounterSigns.REQUEST));
    fetch(POST_ENCOUNTER_SIGNS_API, {
      method: 'POST',
      body: JSON.stringify(postData),
      headers: jsonApiHeader(getState().login.access_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then((response) => {
        if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
          showSuccessMessage(response.message);
          dispatch(actionCreator(soapActionTypes.post_EncounterSigns.SUCCESS, response));
        } else {
          showErrorMessage(response.message);
          dispatch(actionCreator(soapActionTypes.post_EncounterSigns.SUCCESS, null));
        }
      })
      .catch((error) => {
        console.log('error saveEncounterSigns', error);
      });
  };
};



// WEBPACK FOOTER //
// ./src/modules/scheduling/components/SessionNotes_BT_BESTABA/actions/soapActions.js